<template>
    <moe-page>
        <moe-top></moe-top>
        <div class="coupon_box flex Flexjustify Flexalign">
            <div class="content">
                <div class="content_title mar_top_40">商品确认</div>
                <div class="goods_content mar_top_20">
                    <div class="goods_content_top"></div>
                    <div class="goods_content_box">
                        <div class="goods_top flex Flexalign">
                            <div class="goods_name Flexjustify flex Flexalign">试卷名称</div>
                            <div class="goods_empty Flexjustify flex flexcolumn"></div>
                            <div class="goods_orgrnization">机构</div>
                            <div class="goods_orgrnization">优惠券</div>
                            <div class="goods_orgrnization">金额</div>
                        </div>
                        <div class="goods_top goods_info flex Flexalign" v-for="(item, index) in selectOrderList"
                            :key="index">
                            <div class="goods_name goods_name_new Flexjustify flex Flexalign">
                                <el-image class="video_img" :src="iconPath('paper_order_confirm_icon.png')"></el-image>
                            </div>

                            <div class="goods_empty goods_name_text Flexjustify flex flexcolumn">
                                <div>{{ item?.paperDocumentName }}</div>
                                <!-- <div class="goods_reward">购买课程最多可赠送30学分</div> -->
                            </div>
                            <div class="goods_orgrnization">
                                {{ item?.shopName }}
                            </div>
                            <div class="goods_orgrnization">
                                <el-select v-model="item.couponId" placeholder="请选择优惠券" no-data-text="暂无可用优惠券"
                                    size="large" style="min-width: 100px" @visible-change="getUsableCouponList(item)"
                                    @change="getFianlPrice">
                                    <el-option v-for="sitem in usableCouponList" :key="sitem.id"
                                        :label="sitem.couponName" :value="sitem.id" :disabled="sitem.isSelected" />
                                </el-select>
                            </div>
                            <div class="goods_orgrnization">
                                ￥{{ item.price }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="goods_content mar_top_30">
                    <div class="goods_content_box">
                        <div class="goods_content_box_top flex Flexalign FlexBetween">
                            <div>用户名：{{ userInfo.name }}</div>
                            <div class="flex Flexalign">
                                <el-checkbox v-model="isReadAgreement" size="large" />
                                <div class="mar_left_10 agree_text">
                                    我已经阅读并确认签署<span class="active_color cursor_pointer"
                                        @click="openAgreement('course_order_agreement')">《{{ agreementInfo.title
                                        }}》</span>
                                </div>
                            </div>
                        </div>
                        <div class="goods_content_box_bottom flex Flexalign FlexBetween mar_top_30">
                            <div class="flex Flexalign">
                                <div class="total_num">
                                    共结算 {{ selectOrderList.length }} 件商品
                                </div>
                                <div class="price_text" @mouseenter="showPriceInfo" @mouseleave="hidePriceInfo">
                                    价格明细
                                    <div class="user_info_box flex flexcolumn Flexalign" v-if="isOpenPriceInfo">
                                        <div class="flex Flexalign FlexBetween price_info_one">
                                            <div>原价</div>
                                            <div>¥{{ orinceTotalPrice }}</div>
                                        </div>
                                        <div class="flex mar_top_30 Flexalign FlexBetween price_info_one">
                                            <div>学分抵扣</div>
                                            <div>¥0</div>
                                        </div>
                                        <div class="flex mar_top_30 Flexalign FlexBetween price_info_one">
                                            <div>优惠券抵扣</div>
                                            <div>
                                                ¥{{ (orinceTotalPrice - finalPrice).toFixed(2) }}
                                            </div>
                                        </div>
                                        <div
                                            class="flex Flexalign FlexBetween price_info_one mar_top_20 flex-1 price_wait_pay">
                                            <div>待支付</div>
                                            <div>¥{{ finalPrice.toFixed(2) }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex Flexalign">
                                <div class="discount_value">
                                    已优惠：¥{{ (orinceTotalPrice - finalPrice).toFixed(2) }}
                                </div>
                                <div class="wait_pay">待支付：¥{{ finalPrice.toFixed(2) }}</div>
                                <div class="flex Flexalign">
                                    支付方式：<el-select v-model="payTypeValue" placeholder="Select" size="large"
                                        style="width: 100px">
                                        <el-option v-for="item in pyeTypeOption" :key="item.value" :label="item.label"
                                            :value="item.value" />
                                    </el-select>
                                </div>
                                <div class="btn_pay cursor_pointer mar_left_10" @click="payNow">
                                    <div>立即支付</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <payDialog ref="payDialog" :buyType="'examPaper'"></payDialog>
        <agreement ref="agreement"></agreement>
    </moe-page>
</template>

<script>
import payDialog from "@/components/popup/payDialog.vue";
import { mapState } from "vuex";
import agreement from "@/components/popup/agreement.vue";
// import * as config from "@/config/config";
export default {
    name: "GjkcH5OrderConfirm",

    components: {
        payDialog,
        agreement,
    },
    computed: {
        ...mapState({
            userInfo: (state) => state.userInfo,
        }),
    },

    data() {
        return {
            isOpenPriceInfo: false,
            selectOrderList: [],
            orinceTotalPrice: 0,
            carOrderInfo: {
                cartList: [],
                pointsNum: 0,
            },
            isReadAgreement: false,
            showPayTypeFlag: false,
            payTypeValue: 1,
            pyeTypeOption: [
                { label: "微信", value: 1 },
                { label: "支付宝", value: 2 },
            ],
            couponList: [],
            usableCouponList: [],
            finalPrice: 0,
            agreementInfo: {},
            paperDocumentId: '',
            examinationInfo: {},
        };
    },

    mounted() {
        this.paperDocumentId = this.$Jump.getUrlParams(window.location.hash.split("?")[1]).paperDocumentId;
        // type为2是立即购买，直接获取type为2的购物车列表
        // if (type == 2) {
        //     this.getCarList();
        // } else {
        //     let selectOrderList = this.$Jump.getUrlParams(
        //         window.location.hash.split("?")[1]
        //     ).selectOrderList;
        //     this.selectOrderList = JSON.parse(selectOrderList);
        //     this.selectOrderList.forEach((item) => {
        //         this.orinceTotalPrice += item.courseInfo?.coursePrice;
        //         this.finalPrice += item.courseInfo?.coursePrice;
        //         item.couponId = "";
        //     });
        // }
        // this.getCouponList();
        this.getAgreement();
        this.getExaminationInfo();
    },

    methods: {
        // 获取试卷信息
        getExaminationInfo() {
            this.$Api.examination.getExaminationInfo(this.paperDocumentId).then(res => {
                this.examinationInfo = res.data.data;
                this.selectOrderList.push(this.examinationInfo);
                this.selectOrderList.forEach((item) => {
                    this.orinceTotalPrice += item.price;
                    this.finalPrice += item.price;
                    item.couponId = "";
                });
            }).catch(() => { })
        },
        getAgreement() {
            this.$Api.login.getAgreement('course_order_agreement').then(res => {
                this.agreementInfo = res.data.data;
            })
        },
        // 计算价格优惠等
        getFianlPrice() {
            this.finalPrice = 0;
            this.selectOrderList.forEach((item) => {
                if (item.couponId) {
                    let couponInfo = this.couponList.filter(
                        (sitem) => sitem.id == item.couponId
                    )[0];
                    if (this.$Tools.empty(couponInfo)) return;
                    if (couponInfo.couponType == 1) {
                        this.finalPrice += Number(
                            Number(item.courseInfo?.coursePrice) - couponInfo.reduceMoney >= 0
                                ? (
                                    Number(item.courseInfo?.coursePrice) -
                                    couponInfo.reduceMoney
                                ).toFixed(2)
                                : 0
                        );
                    } else {
                        this.finalPrice += Number(Number(
                            Number(item.courseInfo?.coursePrice) -
                            Number(
                                (Number(item.courseInfo?.coursePrice) *
                                    couponInfo.reduceMoney) /
                                10
                            ).toFixed(2)
                        ).toFixed(2));
                    }
                } else {
                    this.finalPrice += Number(item.courseInfo?.coursePrice.toFixed(2));
                }
            });
        },
        // 筛选可用优惠券
        getUsableCouponList(shopInfo) {
            // 筛选机构下优惠券
            this.usableCouponList = this.couponList.filter(
                (item) => item.shopId == shopInfo.shopId
            );
            if (this.$Tools.empty(this.couponList)) return;
            this.usableCouponList = this.couponList;
            // 判断时间（开始时间要小于当前时间）
            this.usableCouponList = this.usableCouponList.filter(item => {
                if (item.startTime) {
                    let startTime = new Date(item.startTime).getTime();
                    let nowTime = new Date().getTime();
                    if (startTime <= nowTime) {
                        return item
                    }
                } else {
                    return item
                }
            })
            // 筛选满减条件满足的优惠券
            this.usableCouponList = this.usableCouponList.filter((item) => {
                if (item.couponType == 1) {
                    if (item.fullMoney <= shopInfo?.courseInfo?.coursePrice) {
                        return item;
                    } else {
                        return;
                    }
                } else {
                    return item;
                }
            });
            // 先遍历如果是已选的优惠券那么设置isSelected为true，禁用该优惠券选择不展示
            this.selectOrderList.forEach((item) => {
                this.usableCouponList.forEach((sitem) => {
                    if (item.couponId == sitem.id) {
                        sitem.isSelected = true;
                    } else {
                        sitem.isSelected = false;
                    }
                });
            });
            // 筛选出可选的优惠券列表
            this.usableCouponList = this.usableCouponList.filter(
                (item) => item.isSelected == false
            );
            return this.usableCouponList;
        },
        // 获取优惠券列表
        getCouponList() {
            let listQuery = {
                page: 1,
                pageSize: 9999,
                shopId: "",
                applyType: 4,
                state: 0, // 0 已领取  1 已使用  2 已过期
            };
            this.$Api.shop
                .getCouponList(listQuery)
                .then((res) => {
                    this.couponList = res.data.data.list.map((item) => {
                        return { ...item, isSelected: false };
                    });
                    this.$forceUpdate();
                })
                .catch(() => { });
        },
        showPayType() {
            this.showPayTypeFlag = true;
        },
        hidePayType() {
            this.showPayTypeFlag = false;
        },
        // 协议弹窗
        openAgreement(type) {
            this.$refs.agreement.agreementShow = true;
            this.$refs.agreement.type = type;
            this.$refs.agreement.getAgreement();
        },
        // 获取购物车列表
        // getCarList() {
        //     this.$Api.shop
        //         .getCarList({ type: 2 })
        //         .then((res) => {
        //             this.selectOrderList = res.data.data;
        //             this.selectOrderList.forEach((item) => {
        //                 this.orinceTotalPrice += item.courseInfo?.coursePrice;
        //                 this.finalPrice += item.courseInfo?.coursePrice;
        //                 item.couponId = "";
        //             });
        //         })
        //         .catch(() => { });
        // },
        // 价格明细
        showPriceInfo() {
            this.isOpenPriceInfo = true;
        },
        hidePriceInfo() {
            this.isOpenPriceInfo = false;
        },
        payNow() {
            // this.carOrderInfo = {
            //     cartList: [],
            //     pointsNum: 0,
            // };
            // this.selectOrderList.forEach((item) => {
            //     this.carOrderInfo.cartList.push({
            //         cartId: item.cartId,
            //         couponId: item.couponId,
            //     });
            // });
            this.placeOrder();
        },
        // 下单
        placeOrder() {
            if (!this.isReadAgreement) {
                this.$Dialog.confirm({
                    message: "请先阅读确认冠军高考专家辅导课购买协议",
                    title: "警告", // 可选，不传则使用默认值'确认'
                    onConfirm: () => {
                        this.isReadAgreement = true;
                        this.placeOrder();
                    }, // 确认后的操作，如调用删除API等
                    onCancel: () => {
                        // console.log("取消支付");
                        // this.$Jump.href("/orderList");
                    }, // 取消后的操作，可选不传则无动作。也可以在这里添加其他逻辑。
                });
                return;
            }
            // if(this.payTypeValue == 2){
            //   this.$Dialog.toast("暂未开通支付宝支付",{type:'warning'});
            //   return
            // }
            this.loading = this.$loading({
                lock: true,
                text: `正在为您下单`,
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$Api.examination
                .placePaperOrder(this.paperDocumentId)
                .then((res) => {
                    this.loading.close();
                    this.$Dialog.confirm({
                        message: "是否立即付款",
                        title: "警告", // 可选，不传则使用默认值'确认'
                        onConfirm: () => {
                            // 此处判断下广州那边暂时还是走模拟支付(资质未下来)
                            // if (config.FILE_BASE_URL == "https://api.nsjty.com") {
                            //   this.tempPay(res.data.data.orderParentId);
                            //    this.$refs.payDialog.orderId = res.data.data.orderParentNo;
                            // } else {
                            this.payOrder(res.data.data.orderId);
                            this.$refs.payDialog.orderId = res.data.data.orderParentNo;
                            this.$refs.payDialog.orderNo = res.data.data.orderNo;
                            // }
                        }, // 确认后的操作，如调用删除API等
                        onCancel: () => {
                            console.log("取消支付");
                            this.$Jump.href("/orderList");
                        }, // 取消后的操作，可选不传则无动作。也可以在这里添加其他逻辑。
                    });
                })
                .catch(() => { });
        },
        payOrder(orderParentId) {
            this.loading = this.$loading({
                lock: true,
                text: `正在进行支付`,
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$Api.examination
                .getPaperOrderQrcode({
                    orderPayType: this.payTypeValue,
                    orderId: orderParentId,
                    qrcodeWidth: 180,
                })
                .then((res) => {
                    this.loading.close();
                    this.$refs.payDialog.unbindShow = true;
                    this.$refs.payDialog.qrCodeValue = res.data.data;
                    this.$refs.payDialog.orinceTotalPrice = this.finalPrice.toFixed(2);
                    this.$refs.payDialog.payType = this.payTypeValue;
                    this.$refs.payDialog.parentId = orderParentId;
                    setTimeout(() => {
                        this.$refs.payDialog.startInterval();
                    }, 800);
                })
                .catch(() => {
                    this.loading.close();
                });
        },
        // 模拟支付
        tempPay(orderParentId) {
            this.loading = this.$loading({
                lock: true,
                text: `正在模拟支付`,
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$Api.course
                .tempPay({ parentId: orderParentId })
                .then(() => {
                    setTimeout(() => {
                        this.loading.close();
                        this.$Dialog.toast("支付成功");
                        this.$Jump.href("/orderList");
                    }, 3000);
                })
                .catch(() => { });
        },
    },
};
</script>

<style lang="scss" scoped>
.coupon_box {
    width: 100%;
    min-height: calc(100vh - $pageTopHeight);
    background: #f3f3f3;

    .content {
        width: $pageMainWidth;
        min-height: calc(100vh - $pageTopHeight);

        .content_title {
            font-weight: bold;
            font-size: 22px;
            color: #2e3d56;

            .integral_attention {
                font-size: 16px;
                color: #666666;
            }
        }

        .goods_content {
            width: $pageMainWidth;
            border-radius: 10px;
            background: #ffffff;

            .goods_content_top {
                width: $pageMainWidth;
                height: 6px;
                background: linear-gradient(90deg, #00d5c2, #00d498);
                border-radius: 10px 10px 0 0;
            }

            .goods_content_box {
                padding: 0 20px;

                .goods_top {
                    padding: 20px 0;
                    box-sizing: border-box;
                    text-align: center;
                    color: #333333;
                    border-bottom: 1px solid rgba(20, 20, 20, 0.1);
                    // font-weight: 600;

                    .goods_name {
                        width: 22%;
                    }

                    .goods_name_new {
                        width: 5%;
                        text-align: end;
                        margin-left: 7%;
                    }

                    .goods_empty {
                        width: 28%;
                        text-align: left;
                        height: 20px;
                    }

                    .goods_name_text {
                        width: 38%;
                        height: 120px;

                        .goods_reward {
                            margin-top: 15px;
                            color: #deae55;
                            font-size: 16px;
                        }
                    }

                    .goods_orgrnization {
                        width: 25%;
                    }

                    .video_img {
                        width: 42px;
                        height: 42px;
                    }
                }

                .goods_info {
                    font-size: 18px;
                }

                .goods_content_box_left {
                    height: 140px;

                    .integral_used {
                        font-weight: bold;
                        font-size: 20px;
                        color: #333333;
                    }

                    .integral_input {
                        margin: 0 35px;
                        color: #333333;
                        font-weight: 600;

                        :deep(.el-input__wrapper) {
                            box-shadow: none;
                            border-bottom: 1px solid #2e3d56;
                            border-radius: 0;
                        }
                    }

                    .coupon_input {
                        margin-left: 35px;
                    }
                }

                .btn_use {
                    width: 150px;
                    height: 48px;
                    background: linear-gradient(90deg, #ff8a4c, #fe5e3c);
                    border-radius: 24px;
                    font-size: 18px;
                    color: #ffffff;
                    line-height: 48px;
                    text-align: center;
                }

                .goods_content_box_top {
                    width: 100%;
                    font-size: 18px;
                    padding-top: 30px;

                    :deep(.el-checkbox.el-checkbox--large .el-checkbox__inner) {
                        width: 20px;
                        height: 20px;
                        border-radius: 50%;
                    }

                    :deep(.el-checkbox__inner::after) {
                        left: 8px;
                        top: 8px;
                    }

                    .agree_text {
                        color: #666666;
                        // font-weight: 600;
                    }

                    .active_color {
                        color: RGBA(82, 225, 193, 1);
                    }
                }

                .goods_content_box_bottom {
                    padding-bottom: 30px;

                    .total_num {
                        font-weight: bold;
                        font-size: 22px;
                        color: #2e3d56;
                    }

                    .price_text {
                        // font-weight: bold;
                        font-size: 20px;
                        color: #666666;
                        margin-left: 20px;
                        padding-bottom: 5px;
                        border-bottom: 1px solid #666666;
                        position: relative;

                        .user_info_box {
                            top: -230px;
                            right: -230px;
                            position: absolute;
                            width: 242px;
                            height: 224px;
                            background: #ffffff;
                            box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.13);
                            border-radius: 10px;
                            font-size: 14px;
                            color: #666666;
                            line-height: 29px;
                            padding: 25px 15px;
                            font-size: 18px;
                            color: #333333;

                            .price_info_one {
                                width: 100%;
                            }

                            .price_wait_pay {
                                color: #ff7a24;
                                border-top: 1px solid rgba(36, 35, 36, 0.1);
                                padding-top: 20px;
                                box-sizing: border-box;
                            }
                        }
                    }

                    .discount_value {
                        font-size: 18px;
                        color: #333333;
                    }

                    .wait_pay {
                        font-size: 18px;
                        color: #ff7a24;
                        margin: 0 25px;
                    }

                    .btn_pay {
                        width: 200px;
                        height: 48px;
                        background: linear-gradient(90deg, #ff8a4c, #fe5e3c);
                        border-radius: 24px;
                        font-size: 18px;
                        color: #ffffff;
                        text-align: center;
                        line-height: 48px;
                        position: relative;

                        .pay_type_box {
                            width: 100%;
                            text-align: center;

                            .weixin_active_icon {
                                width: 34px;
                                height: 34px;
                            }

                            .weixin_text {
                                width: 60px;
                                text-align: left;
                                color: #2ea31b;
                            }

                            .zhifubao_text {
                                width: 60px;
                                text-align: left;
                                color: #1a89fa;
                            }
                        }
                    }
                }
            }
        }
    }
}

:deep(.el-checkbox.el-checkbox--large .el-checkbox__inner) {
    width: 24px;
    height: 24px;
    border-radius: 50%;
}

:deep(.el-checkbox__inner::after) {
    border: 2px solid #fff;
    border-left: 0;
    border-top: 0;
    left: 8px;
    top: 6px;
    height: 10px;
    width: 5px;
}

:deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
    background: linear-gradient(90deg, #00d5c2, #00d498);
    border-color: #00d498;
}
</style>
